/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import './SelfCheckinView.scss'
import React from 'react'
import { Title } from '../../atoms'
import r from '../../../util/Renderer'
import CheckInAction from '../../../action/check_in/index'
import { IconSuccess, IconWrong } from '../../atoms/icon'
import InputForms from '../../organisms/check_ins/InputForms'
import { NormalButton, OutlinedButton } from 'ui-library/dist/external/components'

export default function SelfCheckInView(props) {
  const reservationId = Object.prototype.hasOwnProperty.call(props.match.params, 'reservationId') ? props.match.params.reservationId : null
  const token = Object.prototype.hasOwnProperty.call(props.match.params, 'token') ? props.match.params.token : null

  return (
    <div>
      <div className="row justify-content-center">
        <div>
          <div className="dataProtection">
            <Title>データ保護に関して</Title>
            <p>お客様からご提供されたご予約情報、個人情報はお客様にサービスおよび商品・情報を提供する為等に利用致します。</p>
            <Title>Personal Information Protection Policy</Title>
            <p>The booking information and personal information provided by the guest will be used to provide services, products and information to the customer.</p>
          </div>
        </div>
      </div>

      <InputForms reservationId={reservationId} token={token} forms={props.checkin.forms} prefectures={props.prefectures} />

      <div className="guestform">
        <div className="guestform__label" />
        <div className="guestform__noform container">
          <NormalButton onClick={CheckInAction.addGuest}>+ 宿泊者 Add guest</NormalButton>
        </div>
      </div>

      <div className="guestform">
        <div className="guestform__finish">
          <div className="circle" />
          Finish
        </div>
        <div className="guestform__noform guestform__finish">
          <div className="buttonGroup">
            <OutlinedButton onClick={e => CheckInAction.onRequestSubmit(reservationId, token, props.checkin)}>決定 Submit</OutlinedButton>
          </div>
        </div>
      </div>
      {r.renderIf(props.checkin.completed)(
        <div className="checkinComp">
          <div className="checkinComp__background">
            <div className="checkinComp__image">
              <IconSuccess />
            </div>
            <div className="checkinComp__messages">
              <p className="checkinComp__messages--en">Thank you for your cooperation!</p>
              <p className="checkinComp__messages--jp">ご入力ありがとうございました。</p>
            </div>
          </div>
        </div>
      )}
      {r.renderIf(props.checkin.expired)(
        <div className="checkinComp">
          <div className="checkinComp__background">
            <div className="checkinComp__imageExpired">
              <IconWrong />
            </div>
            <div className="checkinComp__messages">
              <p className="checkinComp__messages--en">Check-in time has expired</p>
              <p className="checkinComp__messages--jp">チェックイン期限が過ぎています。</p>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
